import RequestPhysicalCard from '../../../../banking/components/add-card/RequestPhysicalCard';

const RequestPhysicalCardScreen = () => {
    return <RequestPhysicalCard />;
};

export default RequestPhysicalCardScreen;
